import React from 'react';
import ReactDOM from 'react-dom/client';

import "./utils/style/zero.css"
import "./utils/style/main_SCSS.css"

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);

